export interface LiveChoiceOption {
  id: string;
  label: string;
  hint?: string;
}

interface LiveChoiceButtonsProps {
  prompt: string;
  options: LiveChoiceOption[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function LiveChoiceButtons({ prompt, options, selectedId, onSelect }: LiveChoiceButtonsProps) {
  return (
    <div>
      <p className="font-body text-[0.9rem] text-center text-[var(--text-sec)] mb-5">{prompt}</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {options.map(opt => (
          <button
            key={opt.id}
            type="button"
            onClick={() => onSelect(opt.id)}
            className={`text-left  border px-4 py-4 transition-colors ${
              selectedId === opt.id
                ? 'border-alpine-green-500/50 bg-alpine-green-500/15'
                : 'border-[var(--rule-bright)] bg-[var(--surface)] hover:border-electric-mustard-600/40'
            }`}
          >
            <div className="font-body text-[0.85rem] font-medium text-[var(--text-pri)]">{opt.label}</div>
            {opt.hint && (
              <div className="font-body text-[0.68rem] text-[var(--text-ter)] mt-1">{opt.hint}</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
